<template>
    <div id="health">
        <Banner title="民眾衛教專區" :breadcrumbs="breadcrumbs" type="health"></Banner>
        <div class="container">
            <div class="center_title">
                <Title en="Health education" chtFirst="衛教" chtSecond="資訊" :center="true"></Title>
            </div>
            <section>
                <!-- <div class="foreword">
                    <p>視網膜醫學會官網上衛教資訊，特別感謝由王南凱醫師、吳文權醫師、吳弘鈞醫師、吳宗典醫師、吳為吉醫師、吳佩昌醫師、莊智鈞醫師、許家銘醫師、陳世真醫師、陳立仁醫師、陳珊霓醫師、楊長豪醫師、蔡芳儀醫師、劉沛綱醫師、鄭成國醫師、賴旗俊醫師、龔雅欣醫師 (依姓氏筆畫順序排列) 所提供，以上若有遺漏尚請見諒，歡迎大家踴躍使用。</p>
                    <p class="end">視網膜醫學會秘書處 敬上</p>
                </div> -->
                <div class="list">
                    <div class="item" v-for="(item,index) in infos" :key="index">
                        <div class="content">
                            <div class="date">{{$moment(item.PublishOn).format("YYYY-MM-DD")}}</div>
                            <div class="info">{{item.Title}}</div>
                            <div class="btn_box">
                                <a
                                    class="Orange_btn islogin"
                                    :href="`/HealthEducation/Detail?Id=${item.Id}`"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        x="0px"
                                        y="0px"
                                        width="18"
                                        height="18"
                                        viewBox="0 0 172 172"
                                        style=" fill:#000000;"
                                    >
                                        <g
                                            fill="none"
                                            fill-rule="nonzero"
                                            stroke="none"
                                            stroke-width="1"
                                            stroke-linecap="butt"
                                            stroke-linejoin="miter"
                                            stroke-miterlimit="10"
                                            stroke-dasharray
                                            stroke-dashoffset="0"
                                            font-family="none"
                                            font-weight="none"
                                            font-size="none"
                                            text-anchor="none"
                                            style="mix-blend-mode: normal"
                                        >
                                            <path d="M0,172v-172h172v172z" fill="none" />
                                            <g id="original-icon" fill="#ffffff">
                                                <g id="surface1">
                                                    <path
                                                        d="M32.25,16.125v139.75h107.5v-104.30859l-1.51172,-1.67969l-32.25,-32.25l-1.67969,-1.51172zM43,26.875h53.75v32.25h32.25v86h-86zM107.5,34.60156l13.77344,13.77344h-13.77344zM59.125,69.875v10.75h53.75v-10.75zM59.125,91.375v10.75h53.75v-10.75zM59.125,112.875v10.75h53.75v-10.75z"
                                                    />
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                    <span>詳細內容</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pages">
                    <div class="box">
                        <div class="prev" @click="prevPage"><</div>
                        <a
                            v-for="(page,index) in pageList"
                            :key="index"
                            :class="{'active':page ==nowPage}"
                            :href="`/HealthEducation#Page=${page}`"
                            @click="goUrl(page)"
                        >{{page}}</a>
                        <div class="next" @click="netxPage">></div>
                    </div>
                    <span class="none">，</span>
                    <div class="select">
                        前往第
                        <select v-model="nowPage" @change="goUrl(false)">
                            <option
                                v-for="(page,index) in totalPage"
                                :key="index"
                                :value="page"
                            >{{page}}</option>
                        </select>
                        頁
                    </div>
                    <div class="btn">
                        <a href="/">回首頁</a>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Common from "@/common";
import API from "@/service/conference";
export default {
    name: "health",
    components: {},
    props: {
        healths: {
            type: Object
        }
    },
    data() {
        return {
            breadcrumbs: [
                {
                    url: "/",
                    title: "首頁"
                },
                {
                    title: "民眾衛教專區"
                },
                {
                    url: "/HealthEducation",
                    title: "衛教資訊"
                }
            ],
            detail: false,
            infos: [],
            nowPage: 1,
            totalPageNumber: Number,
            totalPage: [],
            pageList: []
        };
    },
    methods: {
        goUrl(page) {
            const vm = this;
            if (page) {
                vm.nowPage = page;
                window.scrollTo(0, 0);
            } else {
                vm.computePages();
            }
        },
        prevPage() {
            const vm = this;
            if (vm.nowPage == 1) {
                return false;
            } else {
                vm.nowPage -= 1;
                vm.computePages();
            }
        },
        netxPage() {
            const vm = this;
            if (vm.nowPage == vm.totalPageNumber) {
                return false;
            } else {
                vm.nowPage += 1;
                vm.computePages();
            }
        },
        defaultPage() {
            const vm = this;
            for (let i = 1; i <= vm.totalPageNumber; i++) {
                vm.totalPage.push(i);
            }
            let nowPage = Common.GetUrlhash("Page");
            if (nowPage != null) {
                vm.nowPage = nowPage;
                if (nowPage > vm.totalPageNumber) {
                    vm.nowPage = 1;
                    location.href = `/HealthEducation#Page=${vm.nowPage}`;
                }
            } else {
                vm.nowPage = 1;
            }
            vm.computePages();
        },
        computePages() {
            const vm = this;
            // location.href = `/HealthEducation#Page=${vm.nowPage}`;
            vm.pageList = [];
            let division;
            if (vm.nowPage % 5 != 0) {
                division = Math.floor(vm.nowPage / 5);
            } else {
                division = Math.floor(vm.nowPage / 5) - 1;
            }
            if (division >= 1) {
                let Plus = division * 5;
                for (let j = 1; j <= 5; j++) {
                    if (j + Plus <= vm.totalPageNumber) {
                        vm.pageList.push(j + Plus);
                    }
                }
            } else {
                let arr = [];
                let length = vm.totalPageNumber < 5 ? vm.totalPageNumber : 5;
                for (let i = 1; i <= length; i++) {
                    arr.push(i);
                }
                vm.pageList = arr;
            }
            window.scrollTo(0, 0);
            location.href = `/HealthEducation#Page=${vm.nowPage}`;
        }
    },
    computed: {},
    created() {
        const vm = this;
        //正式打API
        if (vm.healths) {
            // API.getHealthEducationList({ page: 1, count: 10 }).then(res => {
            //   if (res.Ok) {
            //     vm.infos = res.Data.HealthEducations;
            //     vm.infos.forEach(item => {
            //       if (item.Title.length >= 30) {
            //         item.Title = item.Title.substr(0, 29) + "...";
            //       }
            //     });
            //     vm.totalPageNumber = Math.ceil(parseInt(res.Data.Total) / 10);
            //     vm.defaultPage();
            //   }
            // });
            let obj = JSON.parse(vm.healths);
            vm.infos = obj.HealthEducations;
            vm.infos.forEach(item => {
                if (item.Title.length >= 30) {
                    item.Title = item.Title.substr(0, 29) + "...";
                }
            });
            vm.totalPageNumber = Math.ceil(parseInt(obj.Total) / 10);
            vm.defaultPage();
        } else {
            vm.infos = [
                {
                    Id: "5d5d4a9b-f19a-474e-90c3-c8ee87c0d359",
                    PublishOn: "2019-08-05T15:06:40",
                    Title:
                        "青光眼濾泡手術相關眼內炎-南台灣-醫學中心的的的的的的的的的的的的的的的的的的的"
                },
                {
                    Id: "5d5d4a9b-f19a-474e-90c3-c8ee87c0d359",
                    PublishOn: "2019-08-05T15:06:40",
                    Title:
                        "青光眼濾泡手術相關眼內炎-南台灣-醫學中心的的的的的的的的的的的的的的的的的的的"
                },
                {
                    Id: "5d5d4a9b-f19a-474e-90c3-c8ee87c0d359",
                    PublishOn: "2019-08-05T15:06:40",
                    Title: "台泰會議心得"
                },
                {
                    Id: "5d5d4a9b-f19a-474e-90c3-c8ee87c0d359",
                    PublishOn: "2019-08-05T15:06:40",
                    Title:
                        "青光眼濾泡手術相關眼內炎-南台灣-醫學中心的的的的的的的的的的的的的的的的的的的"
                },
                {
                    Id: "5d5d4a9b-f19a-474e-90c3-c8ee87c0d359",
                    PublishOn: "2019-08-05T15:06:40",
                    Title:
                        "針對先前中心槳液性脈絡視網膜病變接受過動力力力力力力力力力力力力力力力力力力力"
                },
                {
                    Id: "5d5d4a9b-f19a-474e-90c3-c8ee87c0d359",
                    PublishOn: "2019-08-05T15:06:40",
                    Title:
                        "青光眼濾泡手術相關眼內炎-南台灣-醫學中心的的的的的的的的的的的的的的的的的的的"
                },
                {
                    Id: "5d5d4a9b-f19a-474e-90c3-c8ee87c0d359",
                    PublishOn: "2019-08-05T15:06:40",
                    Title:
                        "青光眼濾泡手術相關眼內炎-南台灣-醫學中心的的的的的的的的的的的的的的的的的的的"
                },
                {
                    Id: "5d5d4a9b-f19a-474e-90c3-c8ee87c0d359",
                    PublishOn: "2019-08-05T15:06:40",
                    Title:
                        "青光眼濾泡手術相關眼內炎-南台灣-醫學中心的的的的的的的的的的的的的的的的的的的"
                },
                {
                    Id: "5d5d4a9b-f19a-474e-90c3-c8ee87c0d359",
                    PublishOn: "2019-08-05T15:06:40",
                    Title:
                        "青光眼濾泡手術相關眼內炎-南台灣-醫學中心的的的的的的的的的的的的的的的的的的的"
                },
                {
                    Id: "5d5d4a9b-f19a-474e-90c3-c8ee87c0d359",
                    PublishOn: "2019-08-05T15:06:40",
                    Title:
                        "青光眼濾泡手術相關眼內炎-南台灣-醫學中心的的的的的的的的的的的的的的的的的的的"
                }
            ];
            vm.totalPageNumber = 8;
            vm.defaultPage();
        }
    },
    mounted() {},
    watch: {
        nowPage: {
            handler(newpage, oldpage) {
                const vm = this;
                if (newpage == oldpage) {
                    return false;
                }
                API.getHealthEducationList({ page: newpage, count: 10 }).then(
                    res => {
                        if (res.Ok) {
                            vm.infos = res.Data.HealthEducations;
                            vm.infos.forEach(item => {
                                if (item.Title.length >= 30) {
                                    item.Title =
                                        item.Title.substr(0, 29) + "...";
                                }
                            });
                        }
                    }
                );
            }
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#health .foreword {
    padding: 0 30px 30px;
    line-height: 1.5;
    letter-spacing: 3px;
    display: flex;
    width: 90%;
    margin: auto;
    flex-wrap: wrap;
}
#health .foreword p {
    width: 100%;
    text-indent: 38px;
    padding: 0 0 10px;
}
#health .foreword .end {
    text-align: right;
}
#health .list {
    background-color: #eee;
    padding: 20px 10px;
    /* min-height: 300px; */
}
#health .list .item {
    background-color: #fff;
    padding: 0 30px;
}
#health .list .item .content {
    display: flex;
    flex-wrap: wrap;
    padding: 20px 10px;
    letter-spacing: 2px;
    line-height: 1.2;
}
#health .list .item + .item > .content {
    border-top: 1px solid #ccc;
}
#health .list .item .content .date {
    width: 10%;
    padding: 12px 0;
}
#health .list .item .content .info {
    width: 70%;
    padding: 12px;
    color: #888;
    /* line-height: 1.5; */
    letter-spacing: 2px;
}
#health .list .item .content .btn_box {
    width: 20%;
    display: flex;
    flex-wrap: wrap;
    flex-grow: 1;
    align-items: center;
    justify-content: space-between;
}

@media screen and (max-width: 1600px) {
    #health .list .item .content .date {
        width: 100%;
    }
    #health .list .item .content .info {
        width: 75%;
        padding: 12px 0;
        line-height: 1.5;
    }
    #health .list .item .content .btn_box {
        width: 25%;
    }
}
@media screen and (max-width: 1200px) {
    #health .list .item .content .date {
        width: 100%;
    }
    #health .list .item .content .btn_box {
        padding: 20px 0;
        justify-content: center;
        width: 175px;
        flex-grow: initial;
        margin: auto;
    }
    #health .list .item .content {
        padding: 20px 0;
    }
    #health .list .item .content .info {
        width: 100%;
    }
    #health .list .item .content .btn_box .btn_w {
        padding-right: 15px;
    }
}
@media screen and (max-width: 767px) {
    #health .list .item {
        padding: 0 10px;
    }
    #health .foreword {
        padding: 0 0 30px;
    }
    #health .list .item .content .btn_box {
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/health.vue